import { createSlice } from '@reduxjs/toolkit';

import svgAdapter from './svgs.adapter';
import actions from './svgs.actions';

import type { LoadingStatus } from 'types/common_types';

type SVGSliceInitialState = {
  status: LoadingStatus;
};

const initialState: SVGSliceInitialState = {
  status: 'idle',
};

const svgs = createSlice({
  name: 'svgs',
  initialState: svgAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actions.getSVGImage.pending, (state, { payload }) => {
        const update = svgAdapter.addOne(state, { uid: payload, status: 'loading' });
        update.status = 'loading';
      })
      .addCase(actions.getSVGImage.fulfilled, (state, { payload }) => {
        const update = svgAdapter.updateOne(state, {
          id: payload.uid,
          changes: {
            ...payload,
            status: 'loaded',
          },
        });
        update.status = 'idle';
        return update;
      })
      .addCase(actions.getSVGImage.rejected, (state) => {
        return { ...state, status: 'error' };
      });
  },
});

export default svgs;
